<template>
  <div id="spin-guided-event-creation-logistics-wrapper">
    <Input
      id="title-input"
      heading="What'll we call this event?"
      placeholder="Event Title"
      @scs-input="titleInput"
    />
    <div id="event-date-time-section">
      <date-picker
        class="scs-input"
        @date-chosen="dateInput"
        :chosenDate="event.date"
        heading="When is this taking place?"
      />
      <time-picker
        class="scs-input"
        id="scs-start-time-picker"
        :initialValue="event.date"
        :time="event.start_time"
        @input="startTimeInput"
        heading="Start Time"
      />
      <time-picker
        class="scs-input"
        id="scs-end-time-picker"
        :initialValue="event.date"
        :time="event.end_time"
        @input="endTimeInput"
        heading="End Time"
      />
    </div>
  </div>
</template>
<script>
import Input from "../../../../Components/Elements/Input.vue";
import DatePicker from "../../../../Components/Elements/DatePicker.vue";
import TimePicker from "../../../../Components/Elements/TimePicker.vue";
export default {
  methods: {
    titleInput(title) {
      this.$emit("titleInput", title);
    },
    dateInput(date) {
      this.date = date;
      this.$emit("dateInput", date);
    },
    startTimeInput(time) {
      this.$emit("startTimeInput", time);
    },
    endTimeInput(time) {
      this.$emit("endTimeInput", time);
    },
  },
  components: {
    Input,
    DatePicker,
    TimePicker,
  },
  emits: ["titleInput", "dateInput", "startTimeInput", "endTimeInput"],
  props: ["event"],
};
</script>
<style scoped>
@media screen {
  #spin-guided-event-creation-logistics-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }

  #title-input {
    width: 300px;
  }

  #event-date-time-section {
    padding: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
  }

  .scs-input {
    margin: 20px;
  }
  @media (min-width: 800px) {
    #spin-guided-event-creation-logistics-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
    }

    #title-input {
      width: 300px;
    }

    #event-date-time-section {
      padding: unset;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
    }
    .scs-input {
      margin: auto;
    }
  }
}
</style>
